
enum Answer {
    UNKNOWN = -1,
    NO = 0,
    YES = 1,
    UNSURE = 2
}

export default Answer;